import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as inSessionCollateralActions from "../actions/intraSeanceCollaterals";
import { GET_SESSION_COLLATERAL_REQUESTED,GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_REQUESTED, GET_ALL_SESSIONS_REQUESTED } from "../types";
import moment from "moment";

function* watchGetCollaterals() {
    yield takeEvery(GET_SESSION_COLLATERAL_REQUESTED, getSessionCollaterals);
  }
function* watchGetSessionCurrentBlockedCollateralDetails() {
    yield takeEvery(GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_REQUESTED, getSessionCurrentBlockedCollateralDetails);
  }
  
  function* watchGetAllSession() {
    yield takeEvery(GET_ALL_SESSIONS_REQUESTED, getAllSessions);
  }
  function* getSessionCollaterals(action) {
    try {
      const res = yield call(apiGetSessionCollateral, action.payload);
      const item =[ res?.data];
      yield put(
        inSessionCollateralActions.getSessionCollateralSucceeded({
          item
        })
      );
    } catch (err) {
      yield put(inSessionCollateralActions.getSessionCollateralFailed());
    }
  }

  function* getSessionCurrentBlockedCollateralDetails(action) {
    try {
      const res = yield call(apiGetSessionCurrentBlockedCollateralDetails, action.payload);
      const item = res?.data;
      yield put(
        inSessionCollateralActions.getSessionCurrentBlockedAmountDetailsSucceeded({
          item
        })
      );
    } catch (err) {
      yield put(inSessionCollateralActions.getSessionCurrentBlockedAmountDetailsFailed());
    }
  }


  function* getAllSessions(action) {
  try {
    const res = yield call(apiGetAllSessions, action.payload);
    let allSessions = res?.data?.items?.reduce((acc, value) => {
      acc.push({
        value: value.id,
        name: moment(value.sessionDate).format("DD-MM-YYYY"),
      });
      return acc;
    }, []);

    yield put(inSessionCollateralActions.getAllSessionsSucceeded(allSessions));
  } catch (err) {
    yield put(inSessionCollateralActions.getAllSessionsFailed());
  }
}
  function apiGetSessionCollateral(reqParams) {
    let sessionDate = reqParams.sessionDate ?? null;
    let organizationId =
      reqParams.organizationId ?? null;
  
    return API_GET("session-collateral", {
      sessionDate,
      organizationId,
    });
  }
  

  function apiGetSessionCurrentBlockedCollateralDetails(req) {
     let sessionDate = req.sessionDate ?? null;
    let organizationId =
      req.organizationId ?? null;
  
    return API_GET("session-collateral/detail", {
      sessionDate,
      organizationId,
    });
  }
  
  function apiGetAllSessions() {
  return API_GET("system-parameter/session/all");
}

  export default function* inSessionCollateralSaga() {
    yield all([fork(watchGetCollaterals), fork(watchGetSessionCurrentBlockedCollateralDetails), fork(watchGetAllSession)]);
  }